import * as React from 'react'
import { useState } from 'react'
import {
    Alert,
    Box,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
} from '@mui/material'

import FieldSelect from './Components/FieldsSelect'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
interface ViewDataMergeDossier {
    props: Array<any>
    kedo: any
    defDossierId: any
    closeModal: () => void
    idDossiers: number[]
}

const MergeDossier: React.FC<ViewDataMergeDossier> = ({
    props,
    kedo,
    defDossierId,
    closeModal,
    idDossiers,
}) => {
    const [modal, setModal] = useState<boolean>(true)
    const [selectedOption, setSelectedOption] = useState<string>('')
    const [next, setNext] = useState<boolean>(true)
    const [finish, setFinish] = useState<boolean>(false)
    const [showAlert, setShowAlert] = useState(false)

    const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target
        setSelectedOption((prev) => (prev === value ? '' : value))
    }

    const confirmationModal = () => {
        if (selectedOption) {
            setNext(false)
            setShowAlert(false)
        } else {
            setShowAlert(true)
        }
    }

    const canDefDossierBeArchived = (ddId: any) => {
        const dds = kedo.env().getCurrentEnvironmentDefDossiers()
        if (dds.length <= 0) {
            return false
        }

        return (
            dds.filter(
                (item: { id: any; archiveable: boolean }) =>
                    item.id === ddId && item.archiveable === true
            ).length > 0
        )
    }

    const renderShow = () => {
        return (
            <>
                <AppDialog
                    aria-labelledby="contained-modal-title-vcenter"
                    open={modal}
                    maxWidth={'lg'}
                    fullWidth
                    title={kedo.t('Merge dossiers')}
                    onClose={() => setModal(false)}
                    headerClose={() => setModal(false)}
                    contentProps={{ dividers: true }}
                    actions={
                        <>
                            {next ? (
                                <StyledButton
                                    onClick={() => confirmationModal()}
                                >
                                    {kedo.t('Next')}
                                </StyledButton>
                            ) : null}
                            {!next ? (
                                <StyledButton onClick={() => setFinish(true)}>
                                    {kedo.t('Finish')}
                                </StyledButton>
                            ) : null}
                            <StyledButton
                                color="secondary"
                                onClick={() => {
                                    setModal(false), closeModal()
                                }}
                            >
                                {kedo.t('Close')}
                            </StyledButton>
                        </>
                    }
                >
                    {next ? (
                        <Box>
                            <p>
                                {kedo.t(
                                    'A new dossier is created with values from the selected files.'
                                )}
                            </p>
                            <p style={{ fontWeight: 'bold' }}>
                                {kedo.t(
                                    'What needs to be done with the old dossiers?'
                                )}
                            </p>
                            <FormControl component="fieldset" fullWidth>
                                <RadioGroup
                                    value={selectedOption}
                                    onChange={handleOptionChange}
                                >
                                    <FormControlLabel
                                        value="keep"
                                        control={<Radio />}
                                        label={kedo.t('Keep')}
                                    />
                                    <FormControlLabel
                                        value="archive"
                                        control={<Radio />}
                                        label={kedo.t('Archive')}
                                        disabled={
                                            canDefDossierBeArchived(
                                                defDossierId
                                            ) !== true ||
                                            (kedo
                                                .env()
                                                .isAllowedDefDossier(
                                                    'archive',
                                                    defDossierId
                                                ) &&
                                                !kedo.isAdminOrEnvironmentAdmin())
                                        }
                                    />
                                    <FormControlLabel
                                        value="delete"
                                        control={<Radio />}
                                        label={
                                            <Box component="span">
                                                {kedo.t('Delete ')}
                                                <Box
                                                    component="span"
                                                    sx={{ color: 'red' }}
                                                >
                                                    {kedo.t('(permanent!)')}
                                                </Box>
                                            </Box>
                                        }
                                        disabled={
                                            defDossierId <= 0 ||
                                            (defDossierId > 0 &&
                                                !kedo
                                                    .env()
                                                    .isAllowedDefDossier(
                                                        'delete',
                                                        defDossierId
                                                    ))
                                        }
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    ) : (
                        <FieldSelect
                            props={props}
                            dossiers={idDossiers}
                            option={selectedOption}
                            onFinish={finish}
                            closeModal={closeModal}
                        />
                    )}
                    {showAlert && (
                        <Alert severity={'info'} sx={{ mt: 2 }}>
                            {kedo.t('You must select an option')}
                        </Alert>
                    )}
                </AppDialog>
            </>
        )
    }

    return renderShow()
}

export default MergeDossier
